import { TMenuIds } from "../../../../app/state/menuSlice/types";
import { TEntityInfo } from "../../../types/utility";
import { ISidebarItem, MenuItems } from "../../types";
import { SidebarItem } from "./SidebarItem";
import styles from "./styles.module.css";

interface Props extends Omit<ISidebarItem, "item" | "handleOpenMenuActions"> {
  menuItems: MenuItems;
  handleItemActions: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    id: TMenuIds,
    info: TEntityInfo | null,
  ) => void;
  withoutActions?: boolean;
  className?: string;
}

export const SidebarList = ({
  menuItems,
  handleItemActions,
  withoutActions = false,
  ...rest
}: Props) => {
  return (
    <ul className={styles["sidebar-list"]}>
      {menuItems.map((item) => (
        <SidebarItem
          key={item.id}
          item={item}
          handleOpenMenuActions={handleItemActions}
          withOutActions={withoutActions}
          {...rest}
        />
      ))}
    </ul>
  );
};
